import { Flex } from 'reflexbox';

import * as graphql from 'generated/graphql';
import MainLayout from 'packages/kakapo-ui-application/layouts/MainLayout';
import Spinner from 'packages/kakapo-ui-kit/components/common/Spinner';
import Column from 'packages/kakapo-ui-kit/components/grid/Column';
import Container from 'packages/kakapo-ui-kit/components/grid/Container';

import FeedbackRespondInstructions from './FeedbackRespondInstructions';
import FeedbackThankYou from './FeedbackThankYou';
import { useHistory } from 'react-router';
import { useEffect } from 'react';

function ExternalKakapoFeedbackRedirectContents(props: { secret: string }) {
	const query = graphql.useExternalKakapoFeedbackQuery({ variables: { secret: props.secret } });
	const history = useHistory();

	useEffect(() => {
		if (!query.data) {
			return;
		}

		const feedback = query.data.externalKakapoFeedback;
		history.push(`/external-feedback/${feedback.responseID}/respond/${feedback.secret}`);
	}, [!!query.data]);

	if (query.loading) {
		return <Spinner isLoading size="18px" />;
	} else if (query.error || !query.data) {
		return <FeedbackThankYou external />;
	} else {
		return null;
	}
}

export default function ExternalKakapoFeedbackRedirect(props: { secret: string }) {
	return (
		<MainLayout>
			<Container>
				<Flex justifyContent="center" flexWrap="wrap">
					<Column my={[4, 4, 5]} width={[1, 1, 6 / 12]} spaced>
						<ExternalKakapoFeedbackRedirectContents secret={props.secret} />
					</Column>

					<Column width={[1, 1, 3 / 12]} p={[0, 0, 4]} pb={[4, 4, 0]} spaced>
						<FeedbackRespondInstructions />
					</Column>
				</Flex>
			</Container>
		</MainLayout>
	);
}
